module.exports = __webpack_public_path__ + "static/baked_for_party-7a3798e73e43bbb79603029852aace3a.jpg";